export class Season {
    constructor() {}
  
    seasonId: string;
    name: string;
    tvShowId: string;
    tvShowName: string;
  }
  


// WEBPACK FOOTER //
// ./src/data/Season.ts